export default function MvpOrcamento() {
  return (
    <section id="orcamento" className="py-20 bg-stone-50">
      <div className="max-w-5xl mx-auto px-6 lg:px-10">
        <div className="flex items-center gap-3 mb-3">
          <div className="w-8 h-8 rounded-lg bg-[#071210] flex items-center justify-center">
            <span className="text-emerald-400 text-xs font-bold">III</span>
          </div>
          <span className="text-stone-400 text-xs uppercase tracking-widest font-medium">Parte III</span>
        </div>
        <h2 className="text-3xl font-bold text-stone-900 mb-2">Equipe e Precificação — Fase 1</h2>
        <p className="text-stone-500 mb-10 text-base">
          Para construir internamente uma plataforma com este escopo, o instituto precisaria montar e manter a seguinte equipe durante os 4 meses de desenvolvimento.
        </p>

        {/* Custo de montar internamente */}
        <div className="mb-10">
          <h3 className="text-base font-semibold text-stone-800 mb-2">Quanto custaria montar esta equipe internamente?</h3>
          <p className="text-stone-400 text-sm mb-5">
            Estimativa baseada em salários CLT de mercado em <strong className="text-stone-600">Manaus/AM</strong> (Catho AM 2025 · Glassdoor BR jan/2026), acrescidos de encargos trabalhistas (INSS, FGTS, férias, 13º) que representam aproximadamente 70% sobre o salário bruto.
          </p>
          <div className="overflow-x-auto rounded-xl border border-stone-200">
            <table className="w-full text-sm">
              <thead>
                <tr className="bg-stone-900 text-left">
                  {['Profissional', 'Salário Bruto/mês', 'Custo Real c/ Encargos', 'Custo em 4 meses'].map((h) => (
                    <th key={h} className="px-4 py-3 text-stone-300 font-medium whitespace-nowrap">{h}</th>
                  ))}
                </tr>
              </thead>
              <tbody className="divide-y divide-stone-100">
                {[
                  ['Dev Full Stack Sênior (IA)', 'R$ 16.000', 'R$ 27.200/mês', 'R$ 108.800'],
                  ['Dev Full Stack Pleno', 'R$ 11.000', 'R$ 18.700/mês', 'R$ 74.800'],
                  ['Dev Full Stack Júnior', 'R$ 6.500', 'R$ 11.050/mês', 'R$ 44.200'],
                  ['Designer UI/UX', 'R$ 8.000', 'R$ 13.600/mês', 'R$ 54.400'],
                  ['Product Manager', 'R$ 12.000', 'R$ 20.400/mês', 'R$ 81.600'],
                  ['Especialista Mestre (Fomento)', 'R$ 14.000', 'R$ 23.800/mês', 'R$ 95.200'],
                  ['Especialista Doutor (Fomento)', 'R$ 18.000', 'R$ 30.600/mês', 'R$ 122.400'],
                  ['Tester / QA', 'R$ 6.500', 'R$ 11.050/mês', 'R$ 44.200'],
                  ['DevOps / Infra', 'R$ 11.000', 'R$ 18.700/mês', 'R$ 74.800'],
                ].map(([prof, salario, custo, total], i) => (
                  <tr key={i} className={i % 2 === 0 ? 'bg-white' : 'bg-stone-50'}>
                    <td className="px-4 py-3 text-stone-700 font-medium">{prof}</td>
                    <td className="px-4 py-3 text-stone-500">{salario}</td>
                    <td className="px-4 py-3 text-stone-600">{custo}</td>
                    <td className="px-4 py-3 font-bold text-stone-900">{total}</td>
                  </tr>
                ))}
                <tr className="bg-stone-900">
                  <td colSpan={3} className="px-4 py-3 text-stone-300 font-semibold">Custo total de montar a equipe internamente por 4 meses</td>
                  <td className="px-4 py-3 font-bold text-red-400 text-base">R$ 700.400</td>
                </tr>
              </tbody>
            </table>
          </div>
          <p className="text-stone-400 text-xs mt-2 italic">
            Este valor não inclui: infraestrutura de TI, licenças de software, recrutamento, onboarding, gestão de RH, rescisões ou riscos de turnover. Também não considera o tempo necessário para a equipe aprender o domínio de fomento FINEP.
          </p>
        </div>

        {/* Comparativo */}
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
          <div className="p-6 rounded-2xl border border-red-200 bg-red-50">
            <p className="text-red-400 text-xs uppercase tracking-wide font-semibold mb-2">Montar internamente</p>
            <p className="text-stone-900 font-bold text-3xl mb-1">R$ 700.400+</p>
            <p className="text-stone-500 text-xs leading-relaxed">Custo mínimo em 4 meses, sem garantia de entrega, sem expertise em fomento FINEP e com todos os riscos de contratação e gestão de equipe.</p>
          </div>
          <div className="p-6 rounded-2xl border border-emerald-200 bg-emerald-50">
            <p className="text-emerald-600 text-xs uppercase tracking-wide font-semibold mb-2">Contratar a Submit.AI</p>
            <p className="text-stone-900 font-bold text-3xl mb-1">R$ 357.000</p>
            <p className="text-stone-500 text-xs leading-relaxed">Entrega garantida em 4 meses, equipe especializada em IA e fomento FINEP, sem encargos trabalhistas, sem risco de turnover e com suporte pós-entrega incluído.</p>
          </div>
        </div>
      </div>
    </section>
  );
}
